const MESSAGES = {
   // OM Allocate Available Quantities (OMD0021) / Insert Detail Lines / Handle Quantity Difference (OMD0022)
   DIFFERENCE_HANDLING_REQUIRES_DETAILS: "Difference Handling is set to '{0}', but there are no detail records. Please add detail record(s), or set Difference Handling to '{1}'.",
   // Mirrors Messages.resx OmNewOrderedQuantityExceedsOrdered - the same refusal, raised client-side first.
   NEW_ORDERED_EXCEEDS_ORDERED: "New Ordered Quantity cannot be greater than Ordered Quantity.",
   COMMIT_FAILED: "Commit failed.",
   // WM Generate Storage Charges (WMD0015). Client-side mirrors of the btnStartClick refusals;
   // the service raises the same text from Messages.resx for a direct API call.
   STORAGE_CHARGES_TRANSACTION_DATE_REQUIRED: "You must select a valid Transaction Date.",
   STORAGE_CHARGES_BEGIN_DATE_REQUIRED: "You must select a valid Begin Date.",
   STORAGE_CHARGES_FREQUENCY_REQUIRED: "You must select a valid Frequency code.",
   STORAGE_CHARGES_STATUS_REQUIRED: "You must select a valid Status code.",
   STORAGE_CHARGES_EFFECTIVE_DATE_REQUIRED: "You must select a valid Effective Date.",
   STORAGE_CHARGES_DEPARTMENT_REQUIRED: "You have chosen to consolidate by Department and left the Department field empty.",
   STORAGE_CHARGES_GENERATION_FAILED: "An error occurred while generating storage charges.",
   STORAGE_CHARGES_NO_TEST_RESULTS: "There are no test results to show. Set Mode to Test Storage Generation and press Start first.",
   // WM Replicate Transactions (WMD0113). Delphi refuses to create the item details when the
   // replicated header's customer no longer matches the source (uWMD0002.PAS:9520-9526).
   REPLICATE_CUSTOMER_MISMATCH: "You have chosen to REPLICATE Transaction Header & Detail Records. However, the Customer selected in this transaction does NOT match the Customer entered in the Original Transaction. Please note that Item Detail records will NOT be created based on the original transaction record.",
   REPLICATE_DETAILS_FAILED: "Failed to replicate the transaction details.",
   REPLICATE_NO_ITEMS_TO_SHIP: "The original transaction has no item lines to replicate.",
   REPLICATE_SHIPMENT_DETAILS_FAILED: "Failed to create the shipment detail records.",
   // WM Default Shipment Item Details (WMD0110), opened after a new shipment header is saved when its
   // profile carries default item lines. The help text is the legacy memo (uWMD0110.dfm edtHelpMemo),
   // its three lines joined; the column and panel captions are the legacy ones.
   DEFAULT_SHIPMENT_ITEMS_TITLE: "Default Shipment Item Details",
   DEFAULT_SHIPMENT_ITEMS_HELP: "The Profile selected for Shipment Transaction has the following items. Please enter the Quantity you wish to ship for each line item and Click the OK button to create the \"Transaction Detail\" record(s). The quantity entered in this screen will be defaulted to the Order & Actual Quantity fields in the transaction detail record based on the stage in this transaction.",
   DEFAULT_SHIPMENT_ITEMS_COL_ITEM: "Item",
   DEFAULT_SHIPMENT_ITEMS_COL_ITEM_DESCRIPTION: "Item Description - 1",
   DEFAULT_SHIPMENT_ITEMS_COL_LOT: "Lot",
   DEFAULT_SHIPMENT_ITEMS_COL_ITEM_AVAILABLE: "Item Available",
   DEFAULT_SHIPMENT_ITEMS_COL_ITEM_NET_AVAILABLE: "Item Net Available",
   DEFAULT_SHIPMENT_ITEMS_COL_ORDER_QUANTITY: "Order Quantity",
   DEFAULT_SHIPMENT_ITEMS_LOT_INFORMATION: "Lot Information",
   DEFAULT_SHIPMENT_ITEMS_LOT_DESCRIPTION: "Description - 1",
   DEFAULT_SHIPMENT_ITEMS_LOT_AVAILABLE: "Available",
   DEFAULT_SHIPMENT_ITEMS_COMMENT: "Comment",
   DEFAULT_SHIPMENT_ITEMS_PROFILE_METHODS: "Profile Methods",
   DEFAULT_SHIPMENT_ITEMS_METHOD_LOT: "Lot",
   DEFAULT_SHIPMENT_ITEMS_METHOD_SUBLOT: "Sublot",
   DEFAULT_SHIPMENT_ITEMS_METHOD_LOCATION: "Location",
   DEFAULT_SHIPMENT_ITEMS_MANUAL: "MANUAL",
   DEFAULT_SHIPMENT_ITEMS_AUTO: "AUTO",
   DEFAULT_SHIPMENT_ITEMS_OK: "OK",
   DEFAULT_SHIPMENT_ITEMS_CANCEL: "Cancel",
   // Mirrors Messages.resx CannotBeNegativeFormat with "Order Quantity" - the same refusal, raised by the
   // grid first; the service refuses it again for a direct API call.
   DEFAULT_SHIPMENT_ITEMS_QUANTITY_NEGATIVE: "Order Quantity cannot be negative.",
   DEFAULT_SHIPMENT_ITEMS_LOAD_FAILED: "Failed to load the default shipment item details.",
   DEFAULT_SHIPMENT_ITEMS_CREATE_FAILED: "Failed to create the default shipment item details.",
   // OM Cumulative Trade Discounts (OMD0023) - the FormShow guards, which refuse to open the popup
   // when the order is missing something the discount calculation needs.
   CUMULATIVE_DISCOUNT_NO_CUSTOMER: "No Customer. Unable to Calculate Discount.",
   CUMULATIVE_DISCOUNT_NO_DISCOUNT_TABLE: "No Discount Table. Unable to Calculate Discount.",
   CUMULATIVE_DISCOUNT_NO_TRANSACTION: "No Current Transaction. Unable to Calculate Discount.",
   CUMULATIVE_DISCOUNT_NO_SHIP_DATE: "No Ship Date. Unable to Calculate Discount.",
   CUMULATIVE_DISCOUNT_APPLIED: "Discount Applied Successfully.",
   CUMULATIVE_DISCOUNT_NOT_APPLIED: "No uncommitted transaction was eligible for the discount, so nothing was updated.",
   CUMULATIVE_DISCOUNT_APPLY_FAILED: "Failed to apply discount.",
   CUMULATIVE_DISCOUNT_LOAD_FAILED: "Failed to load discount data.",
   NO_VENDOR_CROSS_REFERENCE_DATA: "No corresponding vendor cross reference data exists for this vendor/item combination",
   NO_ITEMS_TO_CREATE_PURCHASE_ORDERS: "No items to create purchase orders from.",
   NO_ITEMS_TO_CREATE_REQUISITIONS: "No items to create requisitions from.",
   NO_ITEMS_WITH_VENDORS_SELECTED: "No items with vendors selected. Please assign vendors to items before creating purchase orders.",
   CONFIRM_COMMIT_COMMISSIONS: "Are you sure you want to commit all Commissions for this transaction?",
   PO_PROFILE_REQUIRED: "PO Profile Cannot Be Blank.",
   REQUISITION_PROFILE_REQUIRED: "Requisition Profile Cannot Be Blank.",
   TRANSACTION_ALREADY_IN_LIST: "This transaction is already in the list",
   CREATE_SUCCESS: "Record created successfully.",
   UPDATE_SUCCESS: "Record updated successfully.",
   DELETE_SUCCESS: "Record deleted successfully.",
   NO_ROW_SELECTED: "No row has been selected.",
   ITEM_CHARGES_APPLIED: "Item charges were applied successfully.",
   ITEM_CHARGES_ERROR: "Failed to apply item charges.",
   ITEM_CHARGES_APPLY_ERROR: "An error occurred while applying item charges.",
   ERROR: "Error",
   WARNING: "Warning",
   INFORMATION: "Information",
   CONFIRM: "Confirm",
   // Caption of the Print button a screen hangs its reports off (PrintReportMenu's default), so the
   // button is not spelled out once per screen.
   PRINT: "Print",
   QUANTITY_REMOVED_SUCCESS: "Quantity removed successfully.",
   QUANTITY_REMOVED_ERROR: "Failed to remove quantity.",
   ENTER_QUANTITY: "Please enter a quantity greater than 0.",
   ENTER_QUANTITY_LESS_OR_EQUAL: "Please enter a quantity less than or equal to the available quantity.",
   QUANTITY_UPDATE_SUCCESS: "Quantity updated successfully.",
   QUANTITY_UPDATE_ERROR: "Failed to update quantity.",
   DELETE_CONFIRM: "Are you sure you want to delete the record?",
   ERROR_FORM_SUBMISSION: "Error in form submission. Please check the form for errors.",
   FETCH_ERROR: "Error fetching data. Please try again later.",
   // Customer Account Administration (T20260914.0001). The two status values are what an account can
   // actually be today; the Invited / Disabled - Inactivity / Disabled - Credit Hold states arrive with
   // the account record itself.
   LOADING: "Loading",
   ACCOUNT_STATUS_ACTIVE: "Active",
   ACCOUNT_STATUS_DISABLED: "Disabled",
   ACCOUNT_FORM_NOT_AVAILABLE: "The account form is not available yet.",
   // Mirrors of the server's own refusals, raised client-side first so the operator is told before a
   // round trip. The service raises the same text for a direct API call.
   CUSTOMER_ACCOUNT_CUSTOMER_REQUIRED: "The Customer ID entered could not be verified.",
   CUSTOMER_ACCOUNT_EMAIL_INVALID: "Please enter a valid email address.",
   CUSTOMER_ACCOUNT_CREATED: "The customer account has been created and the invitation has been sent.",
   CUSTOMER_ACCOUNT_RESEND_CONFIRM: "Send a new invitation? The link already sent will stop working.",
   CUSTOMER_ACCOUNT_CANCEL_CONFIRM: "Cancel this invitation? The account will be removed and the email address can be used again.",
   CUSTOMER_ACCOUNT_DISABLE_CONFIRM: "Disable this account? The customer will no longer be able to sign in.",
   CUSTOMER_ACCOUNT_ENABLE_CONFIRM: "Enable this account? The customer will be able to sign in again.",
   TRANSFER_QTY_EXCEEDS_AVAILABLE: "Transfer Quantity is greater than Available Quantity.",
   TRANSFER_ITEMS_SAME: "Original Item and Transfer Item cannot be the same.",
   NO_LOTS_FOUND_FOR_ITEM: "No lots were found for the selected Original Item.",
   COMMIT_TRANSACTION_ERROR_CONFIRM: "Commit Process Failed Due To Data Errors - Would You Like To View The Error Report?",
   NO_RECORD_FOUND_RANGE: "No Records Found Within Given Range",
   PROCESS_COMPLETE: "Process Complete",
   COMMIT_TRANSACTION_SUCCESS: "WM Transactions Committed<br/>Batch Number : {0}<br/>Records Processed : {1}",
   CHARGES_RECALCULATED_SUCCESS: "Charges Recalculated Successfully.",
   TRANSACTION_DETAILS_NO_ROW_SELECTED : "You Must Have a Cancelled Transaction Detail Item To Use This Option",
   ACTUAL_QUANTITY_MIN: "Quantity Actual Cannot less than or eqaul 0.",
   BLANK_LOCATION_CONFIRM: "You have chosen a blank Location. Continue?",
   NO_Location_Transfer: "No Location Transfer occurred.",
   // WM Crate Detail From/To Location (WMD0049). The two explanations are the memo Delphi rebuilds each
   // time the dialog is shown, and which end of the transfer the operator is picking depends on it.
   BLANK_WAREHOUSE_CONFIRM: "You have chosen a blank warehouse. Continue?",
   CRATE_LOCATION_ITEM_TYPE_MISSING: "Item Type Not Available. Cannot set Location Lookup.",
   CRATE_FROM_LOCATION_TITLE: "From Location",
   CRATE_TO_LOCATION_TITLE: "To Location",
   CRATE_ADD_LOCATION_EXPLANATION: "Adding an Item to the Crate REQUIRES a location transfer. The inventory will be moved from this location to the location on the Crate Header.",
   CRATE_REMOVE_LOCATION_EXPLANATION: "Removing an Item from the Crate REQUIRES a location transfer. The inventory will be moved from the location on the Crate Header to this location.",
   ACTUAL_QUANTITY_GREATER_THEN_AVAILABLE :"Actual Quantity Entered Greater Than Available.",
   REQUIRED: "This field is required.",
   SEARCH: "Search",
   RESET: "Reset",
   // Driver Bill of Lading Capture (T20260930.0001). Written for a driver standing at a dock, so they
   // say what to do rather than naming the record the system is working with.
   BOL_PAGE_TITLE: "Send a Bill of Lading",
   BOL_STEP_FIND: "Find your load",
   BOL_STEP_CONFIRM: "Confirm it is the right load",
   BOL_STEP_PHOTOGRAPH: "Take a picture of the signed BOL",
   BOL_SEARCH_PLACEHOLDER: "Freight Bill, BOL, PO or Invoice #",
   BOL_SEARCH_HINT: "Enter any of these numbers from your paperwork.",
   BOL_FIND_LOAD: "Find load",
   BOL_ENTER_NUMBER: "Enter a number from your paperwork first.",
   BOL_LOAD_NOT_FOUND: "No load found for that number. Check the number and try again.",
   BOL_LOAD_LOOKUP_FAILED: "Could not look that up just now. Check your signal and try again.",
   BOL_NO_NUMBER: "No number on your paperwork? Show my loads",
   BOL_NO_LOADS_FOR_DRIVER: "You have no recent loads to choose from.",
   BOL_NOT_MY_LOAD: "Not my load? Search again",
   BOL_FREIGHT_BILL: "Freight Bill",
   BOL_NUMBER: "BOL",
   BOL_STATUS_WAITING: "Waiting on BOL",
   BOL_STATUS_RECEIVED: "BOL received",
   BOL_PALLETS: "Pallets",
   BOL_WEIGHT: "Weight",
   BOL_COMMODITY: "Commodity",
   BOL_TAKE_PHOTO: "Take photo",
   BOL_CHOOSE_PHOTO: "Choose from phone",
   BOL_PHOTO_HINT: "Lay the page flat in good light. Add one picture per page, including any delivery receipt.",
   BOL_NOTE_PLACEHOLDER: "Note for billing (optional)",
   BOL_PAGE: "Page",
   BOL_REMOVE_PAGE: "Remove this page",
   BOL_TOO_MANY_PAGES: "That is as many pages as can be sent at once. Send these, then start again for the rest.",
   BOL_SEND: "Send BOL",
   BOL_SEND_FAILED: "The pictures were not sent. Your photos are still here - check your signal and try again.",
   BOL_SENT_CONFIRMATION: "Sent. The office has your bill of lading.",
   BOL_SEND_ANOTHER: "Send another",
   // The office half of the same feature.
   BOL_RECORD_NUMBER: "Record #",
   BOL_REFERENCE_NUMBER: "Reference #",
   BOL_INVOICE_NUMBER: "Invoice #",
   BOL_CUSTOMER: "Customer",
   BOL_DELIVERED_TO: "Delivered To",
   BOL_DELIVERED: "Delivered",
   BOL_DRIVER: "Driver",
   BOL_POD_STATUS: "POD Status",
   BOL_PAGES: "BOL Pages",
   BOL_BILLING_NOTE: "Note for Billing",
   BOL_SEARCH_TITLE: "Enter Your Query For Driver BOLs",
   BOL_SEARCH_ANY_NUMBER: "Freight Bill / BOL / PO / Invoice #",
   BOL_DELIVERED_FROM: "Delivered From",
   BOL_DELIVERED_TO_DATE: "Delivered To",
   BOL_POD_NOT_AVAILABLE: "Not Available",
   BOL_POD_MISSING: "Missing",
   BOL_POD_NOT_REQUIRED: "Not Required",
   BOL_POD_REQUIRED: "Required",
   BOL_POD_RECEIVED: "Received",
   BOL_ATTACHMENTS: "Attachments",
   BOL_NO_ATTACHMENTS: "No bill of lading has been sent for this load yet.",
   BOL_SENT_BY: "sent by",
   BOL_DOWNLOAD: "Download",
   BOL_PAGES_LOAD_FAILED: "Could not read the attachments for this freight bill.",
   BOL_PAGE_DOWNLOAD_FAILED: "Could not download that page. Please try again.",
   ERROR_GENERATING_REPORT: "Error generating report",
   ERROR_LOADING_REPORT: "Could not load the report. Please try again.",
   PLEASE_SELECT_TRANSACTION: "Please select a transaction first.",
   NO_ITEM_LINES_FOUND_ON_ORDER: "No item lines found on this order.",
   SELECT_DETAIL_LINE_WITH_ITEM: "Select a detail line with an item first.",
   NO_RECORDS_SELECTED: "No records selected.",
   RECORDS_PROCESSED: "Records processed.",
   REQUISITION_DETAIL_VIEWER_TITLE: "Requisition Detail Viewer",
   CELL_DETAIL_LOOKUP_HINT: "Details",
   ITEM_DATA_ENTRY_TITLE: "Item Data Entry",
   LOT_DATA_ENTRY_TITLE: "Lot Data Entry",
   REQUISITION_DETAILS_BANNER_LINE1: 'Use this tool to set PO Requisition details as being "Received".',
   REQUISITION_DETAILS_BANNER_LINE2: "It finds PO Requisition by Item Code and, possibly, Consignee's Item Warehouse.",
   REQUISITION_DETAILS_ALL_WAREHOUSES: "Including All Item Warehouses.",
   REQUISITION_DETAILS_WAREHOUSE_ONLY: 'Using Item Warehouse "{0}" only.',
   REQUISITION_DETAILS_NO_RECORDS_FOUND: "NO RECORDS FOUND!",
   REQUISITION_DETAILS_PROCESSING: "Processing",
   SET_SELECTED_AS_RECEIVED: 'Set Selected as "Received"',
   REPACK_SHIPMENT_RECORD_NOT_FOUND: "Repack shipment record not found.",
   ERROR_GETTING_REPACK_SHIPMENT_RECORD: "An error occurred while getting repack shipment record.",
   ITEM_NOT_FOUND: "Item with code {0} not found.",
   RECORD_NOT_FOUND: "Record not found.",
   SCHEDULING_ACTION_COMPLETE: "Scheduling action completed.",
   SCHEDULING_DAY_UNAVAILABLE: "The selected day is unavailable.",
   ERROR_SELECTING_ITEM: "Error selecting item.",
   ERROR_FINDING_ROW_TO_EDIT: "Error: Could not find row to edit.",
   EMPTY_SUBDETAILS : "You Must Have a Transaction Sub Detail Record To Create Additional Sub Detail Records",
   CHARGES_APPLIED_SUCCESS: "Charges applied successfully.",
   ERROR_APPLYING_CHARGES: "Error applying charges.",
   ERROR_APPLYING_CHARGES_DETAIL: "An error occurred while applying charges.",
   SELECT_AT_LEAST_ONE_CHARGE: "Please select at least one charge to apply.",
   ERROR_FETCHING_CHARGES: "Error fetching charges.",
   ERROR_SAVING_GRID_STATE: "Error saving grid state:",
   SERIAL_NUMBER_VERIFICATION_UPDATE_SUCCESS: "Serial number verification updated successfully.",
   CUSTOM_LOGIC_APPLIED_SUCCESS: "Custom logic applied successfully.",
   EXPORT_SHIPMENT_DATA_SUCCESS: "Shipment data exported successfully.<br/>Refresh the transaction after the shipping labels have been printed to view the generated tracking number.",
   ERROR_EXPORT_SHIPMENT_DATA: "Failed to export shipment data.<br/>",
   ITEM_RATE_SCHEDULE_DETAIL_LOAD_ERROR: "Error loading item rate schedule detail: {0}",
   RATE_SCHEDULES_LOAD_ERROR: "Error loading rate schedules: {0}",
   ITEM_RATE_SCHEDULE_UPDATE_SUCCESS: "Item rate schedule updated successfully.",
   ITEM_RATE_SCHEDULE_UPDATE_ERROR: "Error updating item rate schedule: {0}",
   ITEM_CHARGES_APPLIED_SUCCESSFULLY: "Item charges applied successfully.",
   ITEM_CHARGES_APPLY_ERROR: "Error applying item charges: {0}",
   SELECT_RATE_SCHEDULE: "Please select a rate schedule.",
   PLEASE_SAVE_RECORD_FIRST: "Please save record first.",
   CANNOT_DELETE_ITEM_INVALID_ROW_ID: "Cannot delete item invalid row id",
   CANNOT_DELETE_ITEM_RECEIPT_NOT_SAVED: "Cannot delete item receipt not saved",
   ORDERED_ITEM_DELETED_SUCCESS: "Ordered item deleted successfully",
   FAILED_TO_DELETE_ORDERED_ITEM: "Failed to delete ordered item please try again.",
   PLEASE_SELECT_ITEM_AND_SAVE_RECEIPT: "Please select an item and ensure the receipt is saved.",
   ITEM_ADDED_TO_ORDER_SUCCESS: "Item added to order successfully",
   FAILED_TO_ADD_ITEM_TO_ORDER: "Failed to add item to order please try again.",
   RECEIVING_DATE_MUST_BE_GREATER: "Receiving date must be greater than today's date",
   SUCCESS: "Success",
   UPDATE_PRICES_SUCCESS: "Prices updated successfully",
   ORDERED_QUANTITY_UPDATE_SUCCESS: "Ordered quantity updated successfully",
   FAILED_TO_UPDATE_ORDERED_QUANTITY: "Failed to update ordered quantity please try again.",
   FAILED_TO_COMPLETE_ORDER: "Failed to complete order",
   FAILED_TO_COMPLETE_ORDER_RETRY: "Failed to complete order. Please try again.",
   NEW_RECEIPT_CREATED: "New Receipt Created!",
   RECEIPT_UPDATED: "Receipt Updated!",
   RECEIPT_CREATED_CREATE_ANOTHER: "Your receipt has been created. Do you want to create another ?",
   RECEIPT_UPDATED_CREATE_ANOTHER: "Your receipt has been updated. Do you want to create another ?",
   NEW_SHIPMENT_CREATED: "New Shipment Created!",
   SHIPMENT_UPDATED: "Shipment Updated!",
   SHIPMENT_CREATED_CREATE_ANOTHER: "Your shipment has been created. Do you want to create another ?",
   SHIPMENT_UPDATED_CREATE_ANOTHER: "Your shipment has been updated. Do you want to create another ?",
   UNKNOWN_ERROR_OCCURRED: "Unknown error occurred",
   DELETE_ORDERED_ITEM_CONFIRM: "Are you sure you want to delete this ordered item?",
   DELETE_CONFIRMATION: "Delete Confirmation",
   SHIPMENT_TYPE_REQUIRED: "Transaction Type Must Be a 'Shipment' in Order to Use This option.",
   SELECT_TRANSACTION_DETAIL_ROW: "Please select a transaction detail row first",
   NO_SUBSTITUTE_ITEMS: "No Substitute Items Available For This Item",
   ENTER_ITEM_CODE_OR_REFRESH_CONTROL: "Please enter the Item Code before proceeding OR If Item Code has been Entered Press the TAB KEY to Refresh the Control before proceeding",
   SUBLOT_TYPE_REQUIRED: "Item Type Must be 'Sublot' in Order to Use This option.",
   ALREADY_HAS_LOT_CODE: "This Line Item Record Already Have a Lot Code Assigned - Cannot Use This Option",
   INVENTORY_UNIT_REQUIRED: "Transaction Unit in the Detail MUST be set to 'Inventory' in Order to Use This option.",
   NO_AVAILABLE_QUANTITY_TO_SHIP: "This Item Does Not have any Available Quantity to Ship.",
   READY_OR_COMPLETED_STAGE_REQUIRED: "Transaction Stage Must Be a 'Ready' or 'Completed' in Order to Use This option.",
   NO_AVAILABLE_QUANTITY_TO_SHIP: "This Item Does Not have any Available Quantity to Ship.",
   READY_OR_COMPLETED_STAGE_REQUIRED: "Transaction Stage Must Be a 'Ready' or 'Completed' in Order to Use This option.",
   NO_AVAILABLE_QUANTITY_TO_SHIP: "This Item Does Not have any Available Quantity to Ship.",
   UNDO_ALL_CHANGES_CONFIRM:"Do You Wish To Undo All The Changes And Restore Original Dataset",
   STATUS_MUST_BE_READY_TO_COMMIT_LATER: "This Option Cannot Be Used - Status must be set to Ready to Commit Later",
   CONFIRM_COMMIT_TRANSACTION: "This option will commit this sales order. Continue?",
   FAILED_TO_COMMIT_TRANSACTION: "Failed to commit the sales order.",
   CONTACT_TO_ADMINISTRATOR: "Please contact your administrator for assistance.",
   CONFIRM_APPLY_CUSTOM_FEES: "This option will create order details based on all applicable Custom Fees.\n All existing order details created from Custom Fees will be deleted.\n\nDo you want to continue?",
   CONFIRM_APPLY_MANDATED_FEES: "This option will create order details from mandated fees for this order.\n\nDo you want to continue?",
   CONFIRM_CARD_CONNECT_VOID_REFUND: "Are you sure you want to run Refund process for this transaction?",
   SAVE_HEADER_BEFORE_PROCEEDING: "Please SAVE HEADER Record Before Proceeding.",
   CURRENT_WAREHOUSE_MUST_BE_ENTERED: "Current Warehouse Must Be Entered.",
   NEW_WAREHOUSE_MUST_BE_ENTERED: "New Warehouse Must Be Entered.",
   CURRENT_AND_NEW_WAREHOUSES_MUST_DIFFER: "Current and New Warehouses Must Differ.",
   CONFIRM_UPDATE_PRICES: "This option will recalculate prices and create applicable commissions on this sales order for all detail lines. Continue?",
   STATUS_MUST_BE_READY_TO_COMMIT_LATER_OR_OPEN: "This Option Cannot Be Used - Status must be set to Open",
   MARK_ALL_ITEMS_REVIEWED_CONFIRM: "Mark all items on this order as reviewed?",
   INVENTORY_REVIEW_COMPLETED:"Inventory review completed.",
   SELECT_DETAIL_LINE: "Select a detail line first.",
   PICK_NOTES_UPDATE_SUCCESS: "Pick notes updated.",
   PICK_NOTES_UPDATE_ERROR: "Failed to update the pick notes.",
   SELECT_AT_LEAST_ONE_DETAIL_LINE: "Select at least one detail line.",
   DETAIL_ROW_IDS_MISSING: "Selected rows are missing detail row identifiers.",
   NOT_SIGNED_IN: "You are not signed in.",
   INVENTORY_REVIEW_ERROR: "Failed to complete the inventory review.",
   // OMD0015 "Shipment" dialog (Automatic Lot Selection). AUTO_SELECT_LOTS_PARTIAL_SHIPMENT frames the
   // list of shortfall lines the server returns, the way the legacy warning dialog did
   // (uOMM0000.pas:4595); the lines themselves are server-supplied.
   // WM Transaction stage change (WMD0002): frames the blank-allocation notes the server returns
   // after a SUCCESSFUL stage move. Delphi showed the same dialog via
   // ShowQuantityNotAvailableMessageFromStageChange (uWMD0002.pas:14636) as mtWarning / [mbOK], with
   // the stage change standing; the individual lines are server-supplied from Messages.resx.
   // Heading for the informational dialog shown after a SUCCESSFUL stage change. Deliberately neutral,
   // because the dialog now carries two kinds of note: the blank-allocation ones from
   // SPWM_STAGECHANGE's OUTPUT flags, and the four shipment quantity rules Delphi only evaluated on
   // navigating away from the header (those are suffixed "(WEB ONLY)"). Delphi's own prefix for the
   // allocation set was "The following occured during quantity allocations."; that framing is no longer
   // true for the whole dialog, and its allocation lead line is already the first line of the body
   // (uWMD0002.pas:14591 / :14631), so nothing is lost by generalising the heading.
   STAGE_CHANGE_NOTES: "The stage was changed. Please note the following:",
   AUTO_SELECT_LOTS_TITLE: "Shipment",
   AUTO_SELECT_LOTS_HINT: "Lots are selected automatically for the line items using the criteria specified in the transaction data profile. Change the criteria below to override it for this run.",
   // OM Reset Item Discount (OMD0029). The hint and the zero-discount confirm are the Delphi form's text.
   RESET_ITEM_DISCOUNT_TITLE: "Reset Item Discount",
   RESET_ITEM_DISCOUNT_HINT: "This option allows you to reset the item discount percent. Please note that existing Item Discount will be overwritten in all items with the discount entered here.",
   RESET_ITEM_DISCOUNT_ZERO_CONFIRM: "No Item Discount Entered.<br/><br/>Do You Wish to Continue and Apply ZERO Item Discount to ALL Line Items?",
   // Mirrors Messages.resx OmOrderHasNoDetailLines - the same refusal, raised client-side first.
   ORDER_HAS_NO_DETAIL_LINES: "This order has no detail lines.",
   AUTO_SELECT_LOTS_PARTIAL_SHIPMENT: "The following items were partially or not shipped.<br/>Ordered quantity greater than available quantity:",
   UNDO_LOT_SELECTION_CONFIRM: "Are you sure you want to undo automatic lot selection?",
   UNDO_LOT_SELECTION_SUCCESS: "Automatic lot selection has been undone and the detail quantities restored.",
   CONFIRM_RESEQUENCE_LINE_NUMBERS: "Do You Wish to Apply This Sorting to the Database and Have the Line Numbers Re-Numbered Accordingly?",
   CONFIRM_TRANSFER_TO_DISPATCH: "This option will transfer this order to FM Dispatch. Continue?",
   TRANSFER_TO_DISPATCH_SUCCESS: "Transferred to FM Dispatch completed.",
   TRANSFER_TO_DISPATCH_ALREADY_TRANSFERRED: "Transfer not completed - this order has already been transferred.",
   TRANSFER_TO_DISPATCH_ERROR: "An error occurred during the transfer to FM Dispatch.",
   TRANSFER_TO_DISPATCH_SETUP_ERROR: "This order is not correctly setup to be transferred to FM Dispatch.<br>Make sure that the following criteria are met:<br>&gt; Ship To/Consignee exists<br>&gt; FM Transfer Flag is properly set to transfer to FM<br>&gt; Transaction Type is set to Order/Invoice<br>&gt; Stage is set from \"Pending\" to \"Shipped/Completed\"<br>&gt; Dispatch Object Profile and Shipper are populated in the Trips tab.",
   SERIAL_IMPORT_LAYOUT_NAME_REQUIRED: "Layout Name is required.",
   SERIAL_IMPORT_LAYOUT_SAVED: "Layout saved.",
   SERIAL_IMPORT_LAYOUT_DELETED: "Layout deleted.",
   SERIAL_IMPORT_CHOOSE_DATA_FILES: "Please choose data files for import.",
   SPLIT_ORDER_TITLE: "Split Orders By Ship Date",
   SPLIT_ORDER_TITLE_ADVANCED: "Split Orders By Ship Date - Advanced",
   SPLIT_ORDER_QUANTITY_REQUIRED: "Please Specify Correct Quantity for at least one detail line.",
   SPLIT_ORDER_NEW_LINE_ITEM_REQUIRED: "Please select an Item for every new split line that has a Split/Now quantity.",
   SPLIT_ORDER_CONFIRM: "Split order with the quantities entered?",
   SPLIT_ORDER_COMPLETED: "Split completed.",
   SPLIT_ORDER_DETAILS_PROCESSED: "{0} detail line(s) processed.",
   SPLIT_ORDER_SERIAL_NUMBERS_TITLE: "Select Serial # Records",
   SPLIT_ORDER_SERIAL_NUMBERS_APPLIED: "Serial # selection applied.",
   SPLIT_ORDER_SERIAL_NUMBERS_CANCEL_CONFIRM:
      "Any Serial #'s that have been selected will not be split, and any other changes will not be saved. Do you wish to continue?",
   SPLIT_ORDER_SERIAL_NUMBERS_CANCEL_TITLE: "Selected Records Not Split",
   // OM Split Deposit (OMD0035). Client-side mirrors of Delphi ValidData, GetParentData and the Amount/Percent
   // OnExit checks; the service raises the same text from Messages.resx for a direct API call.
   SPLIT_DEPOSIT_TITLE: "Split Deposit",
   SPLIT_DEPOSIT_PARENT_SAME_AS_CURRENT: "Order number parent is the same as the current order number - re-enter.",
   SPLIT_DEPOSIT_PARENT_COMMITTED: "Parent record has already been committed.",
   SPLIT_DEPOSIT_PARENT_NO_DEPOSIT: "Parent deposit Available Amount is either zero or does not exist.",
   SPLIT_DEPOSIT_PARENT_REQUIRED: "A Parent transaction must exist.",
   SPLIT_DEPOSIT_AMOUNT_REQUIRED: "Amount is required before transfer.",
   SPLIT_DEPOSIT_AMOUNT_NEGATIVE: "Amount cannot be negative.",
   SPLIT_DEPOSIT_PAY_METHOD_REQUIRED: "Pay Method is required before transfer.",
   SPLIT_DEPOSIT_AMOUNT_EXCEEDS_PARENT: "Amount Transfer cannot be greater than Parent Remaining.",
   SPLIT_DEPOSIT_PERCENT_OVER_100: "Percent Transfer cannot be greater than 100%.",
   SPLIT_DEPOSIT_PERCENT_NEGATIVE: "Percent Transfer cannot be negative.",
   SPLIT_DEPOSIT_BALANCE_DUE_NEGATIVE: "Balance Due cannot be negative: {0}.",
   SPLIT_DEPOSIT_LOAD_FAILED: "Error loading Split Deposit data.",
   SPLIT_DEPOSIT_LOAD_PARENT_FAILED: "Error loading parent order.",
   SPLIT_DEPOSIT_FAILED: "Error splitting deposit.",
   // OM Select Cost Components (OMD0038)
   COST_COMPONENTS_TITLE: "Select Cost Components",
   COST_COMPONENTS_LOAD_FAILED: "Error loading cost components.",
   COST_COMPONENT_ASSIGN_FAILED: "Failed to assign the cost component.",
   COST_COMPONENT_REMOVE_FAILED: "Failed to remove the cost component.",
   FIND_TRANSACTION: "Find Transaction",
   CANCEL_ORDER_REVERSE_APPLIED_PAYMENTS:
      "Applied deposit/s exists for this transaction. These must total $0 for the order to be cancelled." +
      "<br/>You may elect to manually offset with negative cash or a negative adjustment." +
      "<br/>The adjustment allows the deposit to be retained as revenue or put to a clearing account that can be used in an AR Credit with the clearing account as detail." +
      "<br/>Another choice is to have the system automatically reverse each applied payment record using the assigned account so the total will be $0." +
      "<br/><br/>Do you wish the system to reverse the applied payments?",
   STAGE_CHANGED_CONFIRM:
      "The Transaction Stage Has Been Changed. Detail Records Will Be UPDATED Upon Saving The Header." +
      "<br/>Do You Wish To Continue?",
   // Fallback only. The wording normally comes from the API (Messages.resx ->
   // RecordChangedByAnotherUser); this is used when the response carries no message.
   // Deliberately says nothing about recovery — the hint below is appended per action.
   RECORD_CHANGED_BY_ANOTHER_USER:
      "This record was changed or deleted by another user since you opened it." +
      " Your changes have not been saved.",
   RECORD_CHANGED_TITLE: "Record Changed",
   // Appended to the message above depending on which recovery action the dialog offers.
   RECORD_CHANGED_RELOAD_HINT: "Please reload the page and try again.",
   RECORD_CHANGED_REFRESH_HINT: "The list will be refreshed with the latest values.",
   RELOAD: "Reload",
   REFRESH: "Refresh",
   // Standard grid delete-confirm wording, shared by every inline-edit grid.
   DELETE_SELECTED_RECORD_CONFIRM: "Delete selected record?",
   CONFIRM_DELETE: "Confirm delete",
   // WM Crate Profile (WMD0064) - the "Crate Defaults" button resolves, and on first use seeds,
   // the profile's template crate before navigating to the Crates Data Entry screen.
   CRATE_DEFAULTS_OPEN_ERROR: "Failed to open the crate defaults.",
   // AR Credit/Collections Follow-up (ARD0009).
   FOLLOW_UP_LOAD_ERROR: "Failed to load the follow-up record.",
   FOLLOW_UP_SAVE_SUCCESS: "Follow-up record saved successfully.",
   FOLLOW_UP_SAVE_ERROR: "Failed to save the follow-up record.",
   FOLLOW_UP_DELETE_HEADER_CONFIRM: "Delete Header Record & Associated Detail Records?",
   FOLLOW_UP_DELETE_SUCCESS: "Follow-up record deleted successfully.",
   FOLLOW_UP_DELETE_ERROR: "Failed to delete the follow-up record.",
   FOLLOW_UP_DETAIL_INSERT_SUCCESS: "Follow-up detail inserted successfully.",
   FOLLOW_UP_DETAIL_UPDATE_SUCCESS: "Follow-up detail updated successfully.",
   FOLLOW_UP_DETAIL_DELETE_SUCCESS: "Follow-up detail deleted successfully.",
   FOLLOW_UP_DETAIL_DELETE_ERROR: "Failed to delete follow-up detail.",
   FOLLOW_UP_DETAIL_NO_DATA: "No follow-up entries found",
   FOLLOW_UP_DETAIL_SAVE_HEADER_FIRST: "Save the header first to add follow-up entries",
   FOLLOW_UP_TRANSACTIONS_LOAD_ERROR: "Failed to load transactions.",
   FOLLOW_UP_SELECT_CUSTOMER: "Select a customer on the Followup tab to see {0}.",
   START_FOLLOW_UP: "Enter AR Collection Notices",
   // Report range macros (the saved filter selections recalled from the report filter screens).
   MACRO_FIND_TITLE: "Find Macro",
   MACRO_SAVE_TITLE: "Save Macro As",
   MACRO_NAME_LABEL: "Macro Name",
   MACRO_SET_AS_DEFAULT: "Load this macro automatically for this report",
   MACRO_NONE_SELECTED: "No macro selected",
   MACRO_CURRENT_LABEL: "Macro: {0}",
   MACRO_MATCHING_COUNT: "Records matching your criteria: {0}",
   MACRO_SEARCH_PLACEHOLDER: "Search macros...",
   MACRO_NAME_REQUIRED: "Please enter a macro name.",
   MACRO_NAME_MAX_LENGTH: "Maximum {0} characters.",
   MACRO_NAME_NOT_SUPPORTED: "Macros cannot be saved for this report - its name leaves no room for a macro name.",
   MACRO_SELECT_ROW: "Please select a macro.",
   MACRO_LOAD_ERROR: "Failed to load the selected macro.",
   MACRO_LIST_ERROR: "Failed to load the macro list.",
   MACRO_SAVE_SUCCESS: "Macro '{0}' saved successfully.",
   MACRO_SAVE_ERROR: "Failed to save the macro.",
   MACRO_OVERWRITE_CONFIRM: "Macro '{0}' already exists. Replace it?",
   MACRO_NO_DATA: "No macros have been saved for this report yet.",
   MACRO_UNSAVED_RANGE: "unsaved range",
   // OM Sales Order "Select Items", and the range dialog that feeds it.
   SELECT_ITEMS_TITLE: "Select Items",
   SELECT_ITEMS_LOTS_TITLE: "Select Items/Lots",
   SELECT_ITEMS_TITLE_WITH_RANGE: "Select Items/Lots — {0} ({1} criteria)",
   SELECT_ITEMS_RANGE_TITLE: "Record Range - IM Item Master",
   SELECT_ITEMS_RANGE_HINT:
      "Choose the fields to filter on from the list, set From/To values, then Apply. Use Find to recall a saved macro or Save to keep this range as one.",
   SELECT_ITEMS_RANGE_APPLY: "Apply",
   SELECT_ITEMS_RANGE_SKIP: "Show All Items",
   SELECT_ITEMS_ADD: "Add Selected Items",
   SELECT_ITEMS_CANCEL: "Cancel",
   SELECT_ITEMS_SAVE_ORDER_FIRST: "Save the order before selecting items.",
   SELECT_ITEMS_ORDERED_REQUIRED: "Enter a positive Ordered quantity for at least one item.",
   SELECT_ITEMS_ADD_FAILED: "Failed to add items.",
   SELECT_ITEMS_ADDED: "Items added to the order.",
   SELECT_ITEMS_ERROR_TITLE: "Error",
   // Column captions - the legacy OMD0027 grid headings (uOMD0027.dfm grdItemsLots).
   SELECT_ITEMS_COL_WAREHOUSE: "WH",
   SELECT_ITEMS_COL_ITEM: "Item",
   SELECT_ITEMS_COL_ITEM_DESCRIPTION: "Description 1 - Item",
   SELECT_ITEMS_COL_LOT: "Lot",
   SELECT_ITEMS_COL_LOT_DESCRIPTION: "Description 1 - Lot",
   SELECT_ITEMS_COL_ITEM_AVAILABLE: "Item - Avl",
   SELECT_ITEMS_COL_ITEM_NET_AVAILABLE: "Item - Net Avl",
   SELECT_ITEMS_COL_LOT_AVAILABLE: "Lot - Avl",
   SELECT_ITEMS_COL_LOT_NET_AVAILABLE: "Lot - Net Avl",
   SELECT_ITEMS_COL_ORDERED: "Ordered",
   SELECT_ITEMS_COL_PRICE: "Price",
   SELECT_ITEMS_COL_DISC_PERCENT: "Disc %",
   SELECT_ITEMS_COL_DISC_PRICE: "Disc Price",
   SELECT_ITEMS_COL_AMOUNT: "Amount",
   SELECT_ITEMS_COL_ROW_ID: "Row Id",
   SELECT_ITEMS_COLUMN_CHOOSER: "Choose Column",
   SELECT_ITEMS_COLUMN_SEARCH: "Search column",
   // SR-048727 Net Available warnings. Wording follows the legacy OnValidate messages
   // (uOMD0027.cdsItemsLotsOrderedValidate); the profile's ITEMLOTNETAVAILWARNING decides which suffix
   // applies - 'S' blocks, anything else asks.
   SELECT_ITEMS_ITEM_NET_AVAIL_EXCEEDED: '"Ordered" is greater than "Item Net Available" quantity.',
   SELECT_ITEMS_LOT_NET_AVAIL_EXCEEDED: '"Ordered" is greater than "Lot Net Available" quantity.',
   SELECT_ITEMS_NET_AVAIL_CONTINUE: "Do you wish to continue?",
   SELECT_ITEMS_NET_AVAIL_BLOCKED: "Cannot continue - please change quantity.",
   SELECT_ITEMS_NET_AVAIL_TITLE: "Net Available",
   // Quantity Status Check By Stage (OMTRANSACTIONDP.STATUSCHECK_*), checked before Net Available as
   // cdsItemsLotsOrderedValidate does. Shares the CONTINUE / BLOCKED suffixes above.
   SELECT_ITEMS_AVAILABLE_EXCEEDED: '"Ordered" is greater than "Available" quantity.',
   SELECT_ITEMS_AVAILABLE_TITLE: "Available",
   // Range dialog note, from uOMD0027.GetSelectionMessage (typo "Availabe" corrected).
   SELECT_ITEMS_AVAILABLE_ONLY_NOTE:
      "Note: Only items with positive Available Quantities will be retrieved, because your OM Transactions Data Profile record is set to only display items with Available Quantities.",
   SELECT_ITEMS_ALL_AVAILABILITY_NOTE:
      "Note: Even items with ZERO or NEGATIVE Available Quantities will be retrieved, because your OM Transactions Data Profile record is set to not filter items with Available Quantities.",

   // WM Calculate Deferred Handling Revenue (legacy WMD0088). The four validation strings and the
   // two AC_JOURNAL_* results are the legacy wording verbatim (uWMD0088.pas:339, 347, 357, 366, 681, 685).
   DEFERRED_REVENUE_AS_OF_DATE_REQUIRED: "You must select a valid As Of Date.",
   DEFERRED_REVENUE_STATUS_REQUIRED: "You must select a valid Status.",
   DEFERRED_REVENUE_DEBIT_ACCOUNT_REQUIRED: "You must select a valid debit Account.",
   DEFERRED_REVENUE_CREDIT_ACCOUNT_REQUIRED: "You must select a valid credit Account.",
   DEFERRED_REVENUE_NO_RESULTS: "No deferred revenue was found for the selected As Of Date and filters.",
   CALCULATING_DEFERRED_REVENUE: "Calculating Deferred Handling Revenue...",
   CREATING_AC_JOURNAL: "Creating AC Journal Transaction...",
   AC_JOURNAL_CREATED: "AC Journal Transaction was successfully created.",
   AC_JOURNAL_CREATE_ERROR: "An error was encountered while generating the AC Journal.",
   // The legacy print/preview reports are not migrated; the buttons stay for parity but are disabled.
   PRINTING_NOT_AVAILABLE: "Printing is not available on this screen. Use the grid Export button to export the results.",
   // WM Adjust Available/Unavailable Status (WMD0051). Wording follows the Delphi form; the legacy
   // typos ("higer", "realy", "seleted") are corrected here.
   ADJUST_AVAILABLE_EXCEEDS_TOTAL: "Available quantity cannot be higher than the sum of Available and Unavailable.",
   ADJUST_AVAILABLE_NEGATIVE: "Available quantity cannot be negative.",
   ADJUST_REASON_REQUIRED: "Please select a Reason.",
   // WM Transaction Data Entry, shipment negative-inventory check on leaving the header
   // (uWMD0002.pas:5322 and :5332). Verbatim from Delphi; the API carries the same two strings as
   // Messages.TransactionNegativeAvailableExists / TransactionNegativeNetAvailableExists for the
   // stage-change path.
   NEGATIVE_AVAILABLE_QUANTITIES_EXIST: "Negative Available Quantities Exist For At Least One Line Item In This Transaction. Please Correct Your Data Before Proceeding.",
   NEGATIVE_NET_AVAILABLE_QUANTITIES_EXIST: "Negative Net Available Quantities Exist For At Least One Line Item In This Transaction. Please Correct Your Data Before Proceeding.",
   ADJUST_NOTHING_TO_ADJUST: "Nothing to adjust.",
   ADJUST_CONFIRM_AVAILABLE_TO_UNAVAILABLE: "You have selected to transfer AVAILABLE quantity to UNAVAILABLE quantity for the selected record set. Do you really wish to continue with this process?",
   ADJUST_CONFIRM_UNAVAILABLE_TO_AVAILABLE: "You have selected to transfer UNAVAILABLE quantity to AVAILABLE quantity for the selected record set. Do you really wish to continue with this process?",
   // Shown by menu entries that exist for parity with the Delphi screens but are not migrated yet.
   FUNCTIONALITY_UNDER_CONSTRUCTION: "Functionality under construction.",
   // WM Update Free Days and Grace Periods (WMD0012). The empty-Release-Date confirmation text is NOT
   // here: it carries a server-supplied count, so it comes from Messages.resx.
   FREE_DAYS_AS_OF_DATE_REQUIRED: "As Of Date is required when Date to Use is Specific As Of Date.",
   FREE_DAYS_NO_CHARGES_FOUND: "No Free Days or Grace Period charges matched the selected date and filters.",
   UPDATING_FREE_DAYS: "Updating Free Days and Grace Periods...",
   PREVIEWING_FREE_DAYS_CHARGES: "Loading charges...",
   ALL_RECORDS_SELECTED_CONFIRM: "All records have been selected to be processed.<br/>Do you wish to continue?",
   // Counterpart of ALREADY_HAS_LOT_CODE: the sublot path requires a lot, the lot path forbids one.
   NO_LOT_CODE_ASSIGNED: "This Line Item Record Does NOT Have a Lot Code Assigned - Cannot Use This Option",
   SHIP_EXPIRATION_CONTINUE_QUESTION: "Do you wish to continue?",
   LOCATION_CLASS_MISMATCH: "The Item's Reserve Location Class Code {0} and Sub Class Code {1} do not match.<br/>The Location Class Code {2} and Sub Class Code {3}.",
   // Mirrors Messages.resx ShipExpirationViolationFormat. Kept in step with it by hand: the check runs
   // client-side as each checkbox is toggled, and again server-side as the backstop.
   SHIP_EXPIRATION_VIOLATION: "{0} <br/>Ship Date: {1}<br/>Expires: {2}<br/>Minimum Required Ship Days: {3}<br/>Last Ship Date: {4}.<br/><br/>Please get management approval BEFORE proceeding.",
   SAVE_OR_CANCEL_DETAIL_FIRST: "You must CANCEL or SAVE the current Transaction Detail before using this option.",
   // OMD0026 FormClose, which aborts the close while the dataset is still in dsEdit rather than
   // dropping the pending change ("Please SAVE or CANCEL Before Proceed").
   SAVE_OR_CANCEL_BEFORE_CLOSE: "Please save or cancel the pending change before closing.",
   // OMD0026 is keyed off the selected detail line's item, so it is only reachable from an inventory
   // line that has one. Shown both by the toolbar guard and by the popup when it opens without one.
   OPEN_TRANSACTIONS_SELECT_ITEM_LINE: "Select an inventory detail line with an item before opening open transactions.",
   // OMD0026 AfterPost. Deliberately does not name a field: the same store callback fires for the
   // quantity cell and for the back order cell.
   OPEN_TRANSACTIONS_CHANGE_SAVED: "Change saved.",
   // OM Charge & Hold Shipment - Actual Ship Items (uOMD0037). The cell checks run client-side only, as
   // Delphi's OnSetText/OnValidate did; the save refusals come back from Messages.resx. {0} = warehouse,
   // {1} = the location code typed. "quantitiy" in Delphi's lot message is corrected here.
   CH_SHIP_LOT_BLANK: "Lot cannot be blank",
   CH_SHIP_LOT_NOT_FOUND: "The specified Lot \"{0}\" was not found or does not have available quantity.",
   CH_SHIP_LOCATION_NOT_FOUND: "The specified WH/Location \"{0}/{1}\" was not found.",
   CH_SHIP_LOCATION_NO_SHIPMENTS: "The specified WH/Location \"{0}/{1}\" does not allow Shipment operations.",
   // uOMD0000 EditChargeAndHoldShipmentLocations, shown as information (ab_ShowMessage) before the dialog opens.
   CH_SHIP_STAGE_REQUIRED: "\"Charge & Hold\" Shipment locations can be manually changed only after the transactions stage is set to \"Assigned\" and Lot is specified in the transaction detail.",
   CH_SHIP_OPEN_STATUS_ONLY: "Open status only",
   CH_SHIP_QUANTITY_INVALID: "Ship Quantity cannot be blank and must be greater than or equal to 0",
   CH_SHIP_COUNT: "Count: {0}",
   CH_SHIP_TOTAL: "Total: {0}",
   // WM Enter Weights (uWMD0111). The second sentence is the legacy edtHelpMemo verbatim from the
   // DFM - it is the clearest statement anywhere that this screen assigns a QUANTITY, not a weight.
   // The first sentence drops Delphi's "read from the scale": the serial-scale half is not
   // implemented, so both weights are keyed in.
   ENTER_WEIGHTS_HELP: "This option calculates the Net Weight from the Gross Weight and the Tare Weight entered by the user. The Net Weight quantity calculated will be assigned to the \"Ordered & Actual\" quantity fields in the Transaction Sub Detail record.",
   WEIGHT_QUANTITIES_UPDATED: "Ordered and Actual quantities updated from the weights entered.",
   WEIGHT_QUANTITIES_UPDATE_FAILED: "Unable to update the Ordered and Actual quantities.",
   // Before the Ready stage only the Ordered (pending) quantity is maintained, so the toast must
   // not claim Actual was touched. See the STAGE RULE note in EnterWeights.js.
   WEIGHT_ORDERED_QUANTITY_UPDATED: "Ordered quantity updated from the weights entered.",
   WEIGHT_ORDERED_QUANTITY_UPDATE_FAILED: "Unable to update the Ordered quantity.",
   // Live preview in the Enter Weights popup, so the operator can see what OK will do before
   // pressing it - including that Actual does not move before the Ready stage.
   WEIGHT_PREVIEW_TITLE: "On OK, this sublot becomes",
   WEIGHT_PREVIEW_ORDERED: "Ordered",
   WEIGHT_PREVIEW_ACTUAL: "Actual",
   // Delphi maintains QUANTITYACTUAL only at the Ready and Completed stages; before that only
   // the Ordered (pending) quantity moves. uWMM0002.PAS:7146-7153 and uWMD0002.pas:9105-9108.
   WEIGHT_PREVIEW_ACTUAL_UNCHANGED: "unchanged before the Ready stage",
   SUBLOT_ROW_REQUIRED: "Select a sublot record before using this option.",
   // uWMD0002.pas:14725 verbatim (trailing space dropped). This guard is load-bearing, not
   // belt-and-braces: ValidateTransactionSubDetailError does not cover a missing sublot code.
   SUBLOT_CODE_REQUIRED: "You Must have a Sublot Code entered Before Proceeding with This Option",
   // uWMD0002.pas:17873 verbatim (trailing space dropped). Delphi raises this as mtError.
   SAVE_LOCATION_RECORDS_FIRST: "Please SAVE LOCATION Records Before Proceeding",
   // No legacy counterpart: Delphi wrote QUANTITYACTUAL unconditionally, but the modern app derives
   // it when a sublot spans more than one location and the grid already refuses to edit that cell.
   SUBLOT_ACTUAL_DERIVED_FROM_LOCATIONS: "The Actual quantity for this sublot is derived from its location records and cannot be set from this option.",
   // WM Generate Repeating Misc Charges (legacy WMD0094). The three Start confirmations are
   // uWMD0094.pas btnStartClick, kept VERBATIM by team decision (AI8 parity). They are duplicated from
   // Messages.resx rather than fetched, because the client asks all three locally in one pass — the
   // server holds the same text so it can refuse an unacknowledged direct POST.
   REPEATING_CHARGES_NO_FILTER_CONFIRM:
      "No Filter Criteria Was Specified. ALL Transactions Will Be Updated.<br/>Do You Wish To Continue?",
   REPEATING_CHARGES_DAY_BLANK_CONFIRM:
      'You Did Not Specify A Day Of The Month.<br/>Continue With Day = "1"?',
   // KNOWINGLY INACCURATE and kept that way: the procedure raises @InDay below 1 to 1, so the generated
   // date moves forward one day rather than staying the same. See the Messages.resx comment.
   REPEATING_CHARGES_SLIDING_DAYS_ZERO_CONFIRM:
      "# Of Days Is Blank Or Is Set To 0 - Repeating Transactions Will Be Generated But The Transaction Date Will Remain The Same.<br/>Continue ?",
   REPEATING_CHARGES_NO_TRANSACTIONS_FOUND:
      "No recurring miscellaneous transactions matched the selected filter.",
   // ab_WaitDialogShow text (uWMD0094.pas Process); the legacy double space is collapsed.
   GENERATING_REPEATING_CHARGES: "Replicating Transactions. Please Wait...",
   PREVIEWING_REPEATING_CHARGES: "Loading transactions...",

   // WM Transfer Shipments To Dispatch (WMD0077). The screen asks nothing before it runs, so unlike the
   // sibling operations there are no confirmation strings here.
   TRANSFER_TO_DISPATCH_NO_TRANSACTIONS_FOUND:
      "No receipts or shipments matched the selected filter. Records must have a Shipper, a Transport Carrier, an FM Profile — and a Consignee for shipments — to be transferred.",
   // ab_WaitDialogShow text (uWMD0077.pas Process), verbatim.
   TRANSFERRING_SHIPMENTS_TO_DISPATCH: "Transfering Receipts/Shipments to Freight Management",
   PREVIEWING_SHIPMENTS_TO_DISPATCH: "Loading transactions...",

   // WM Purge Never Used Items, Lots and Sublots (WMD0120).
   //
   // Both confirmations live here, not server-side: they are acknowledgements rather than validation —
   // neither needs the database and neither changes what the run does. <br/> rather than \n because
   // DevExtreme's confirm() takes messageHtml and puts it into the DOM as markup, where a newline is
   // only whitespace. The first is verbatim from uWMD0120.pas btnStartClick, three lines as the Delphi
   // dialog has them; the second has no legacy counterpart — AI8 purged everything silently when the
   // where-builder was left empty.
   PURGE_MASTER_RECORDS_CONFIRM:
      "Are you aware that this program will DELETE records from master tables?<br/>Please make sure you have a BACKUP of your current ABECAS Insight database.<br/>Do you wish to continue?",
   PURGE_NO_FILTER_CRITERIA_CONFIRM:
      "No filter criteria was specified. EVERY never-used record at the selected level will be PERMANENTLY DELETED.<br/>Do you wish to continue?",
   // Checked on the client before Preview or Start posts, so an unusable checkbox combination costs no
   // round trip. Word-for-word what the server answers — string.Format(Messages.Invalid, "Record
   // Selection") — because the server keeps the same check: this one IS validation, not an
   // acknowledgement, and a direct API call must not get past it.
   PURGE_INVALID_RECORD_SELECTION: "You Have NOT Selected Update Records Selection",
   // Shown when GetReport never came back for the selected level, so the Available Fields list is empty.
   PURGE_FIELDS_LOAD_FAILED: "The filter fields could not be loaded. Please try again.",
   PURGE_LOADING_FIELDS: "Loading filter fields...",
   PURGE_NO_RECORDS_FOUND:
      "No never-used records matched the selected filter. A record is purgeable only when it has no WM transaction detail, no IM transaction location, no count detail, and zero quantity in every bucket.",
   // ab_WaitDialogShow text (uWMD0120.pas btnStartClick), verbatim.
   PURGING_NEVER_USED_RECORDS: "Deleting Records - Please Wait",
   PREVIEWING_NEVER_USED_RECORDS: "Loading records...",

   // WM Set Unused Lots To Inactive Status (legacy WMD0068).
   //
   // The first is an acknowledgement the web screen adds - AI8 asked nothing before it ran - because the
   // run writes STATUS and the Recurring Storage Flag across master records. It is softer than the purge
   // screen's: this one is reversible, since both fields stay editable on the Lot and Sublot screens.
   SET_INACTIVE_CONFIRM:
      "This will update the STATUS and/or Recurring Storage Flag of the selected Lot, Sublot and Unit records.<br/>Do you wish to continue?",
   SET_INACTIVE_NO_FILTER_CRITERIA_CONFIRM:
      "No Record Range criteria was specified. EVERY record with zero inventory last updated on or before the date entered will be updated.<br/>Do you wish to continue?",
   // Verbatim from uWMD0068.pas - both btnStartClick and btnPreviewClick show this exact text when no
   // checkbox is ticked and neither storage flag was chosen. The server rejects the same payload with the
   // shared "Invalid {0} Provided", which only a caller bypassing this screen ever sees.
   SET_INACTIVE_NO_SELECTIONS: "You Have NOT Made Any Selections",
   // Word-for-word what the server answers for the same payload - string.Format(Messages.RequiredFormat,
   // "Last Update Date") - so a user who trips it on the client and a caller who trips it on the API read
   // the same sentence. "Last Update Date" rather than the field's own shorter "Last Update" caption,
   // because that is the group header the user is looking at.
   SET_INACTIVE_DATE_REQUIRED: "Last Update Date is required.",
   // ab_WaitDialogShow text (uWMD0068.pas btnStartClick), verbatim.
   SET_INACTIVE_UPDATING: "Updating Records - Please Wait",
   SET_INACTIVE_PREVIEWING: "Loading records...",
   // Shown when GetReport never came back, so the Available Fields list is empty.
   SET_INACTIVE_FIELDS_LOAD_FAILED: "The filter fields could not be loaded. Please try again.",
   SET_INACTIVE_LOADING_FIELDS: "Loading filter fields...",
   // noDataText for this screen's Preview grid. It names IM Item Master deliberately: the preview is the
   // Record Range's own result set, not the lots the run would touch, and an empty one means the range
   // selected no items at all.
   SET_INACTIVE_NO_RECORDS_FOUND:
      "No IM Item Master records matched the Record Range. Note that this Preview lists the items your criteria select, not the Lot, Sublot or Unit records the update would change.",

   // WM Delete Item Tasks (legacy WMD0124).
   //
   // Verbatim from uWMD0124.pas btnStartClick, which asks exactly this before it runs. <br/> because
   // DevExtreme's confirm() takes messageHtml and puts it into the DOM as markup, where the Delphi's
   // #13#10 would only be whitespace.
   DELETE_TASKS_CONFIRM:
      "You about to delete Item Tasks.<br/>Do You Wish To Continue?",
   // The web screen's own second question - AI8 has none. The grid IS the delete list on this screen, so
   // running Start without having looked at it is the one mistake worth asking about.
   DELETE_TASKS_NOT_PREVIEWED_CONFIRM:
      "The task list has not been previewed for the dates entered. Preview first to see exactly which Item Tasks will be deleted.<br/>Continue without previewing?",
   // ab_WaitDialogShow text (uWMD0124.pas btnStartClick), verbatim.
   DELETE_TASKS_DELETING: "Deleting Item Tasks - Please Wait",
   DELETE_TASKS_LOADING: "Loading Item Tasks...",
   // Word-for-word what the server answers for the same payload, so the client and the API read alike.
   DELETE_TASKS_START_DATE_REQUIRED: "Start Date is required.",
   DELETE_TASKS_NUMBER_DAYS_INVALID: "Invalid Number Days Provided",
   // noDataText for the grid. Spells out both ways a task qualifies, because the screen's two inputs
   // explain only one of them and an empty grid otherwise looks like the dates are wrong.
   DELETE_TASKS_NO_RECORDS_FOUND:
      "No Item Tasks qualify for the dates entered. A task is deleted only when it is a committed Location Transfer completed before the cut-off, or when the transaction it belongs to was committed and received/shipped before the cut-off.",

   // Footer of the shared where-builder Preview dialog, verbatim from the Delphi framework
   // (SearchFm.pas TLookupForm.qrySearchAfterOpen: 'Records matching your criteria: ' + RecordCount).
   // Named generically, not per-screen: every operation screen that previews a where-builder result set
   // shows this same footer in AI8, so the sibling screens can adopt this key as they are revisited.
   //
   // The legacy has a second variant, 'Records matching your criteria: First N', used when the query hit
   // the AB_MAXRECNUM cap. Not ported: the web Preview applies no row cap, so it can never be the
   // truthful message. Add it only alongside an actual cap.
   //
   // The legacy zero-row branch ('No Records Were Found...') is not ported either - the grid already
   // says so through noDataText, and showing it in two places at once reads as a bug.
   PREVIEW_RECORDS_MATCHING_FORMAT: "Records matching your criteria: {0}",
   // OM Items With Unavailable Quantities - the sales order stage change gate (legacy OMD0016).
   // Server-supplied text (Insufficient Quantity, the availability-changed re-check, the block
   // reason) comes from Messages.resx and is displayed as returned; only the popup's own chrome
   // lives here.
   UNAVAILABLE_QUANTITIES_TITLE: "Items With Unavailable Quantities",
   UNAVAILABLE_QUANTITIES_SHOW_ALL: "Show All",
   UNAVAILABLE_QUANTITIES_SHOW_INSUFFICIENT: "Show Insufficient",
   UNAVAILABLE_QUANTITIES_CONTINUE: "Continue",
   UNAVAILABLE_QUANTITIES_CANCEL: "Cancel",
   UNAVAILABLE_QUANTITIES_ASSIGNED_LOCATIONS: "Assigned Locations",
   UNAVAILABLE_QUANTITIES_AVAILABLE_LOCATIONS: "Available Locations",
   UNAVAILABLE_QUANTITIES_ITEM_STATUS: "Item - Quantity Status",
   UNAVAILABLE_QUANTITIES_LOT_STATUS: "Lot - Quantity Status",
   UNAVAILABLE_QUANTITIES_SELECT_ROW: "Select a line to see its quantity status and locations.",
   UNAVAILABLE_QUANTITIES_BANNER: "Insufficient Available Quantity",
   UNAVAILABLE_QUANTITIES_REPORT: "OM Insufficient Quantity Report",
   UNAVAILABLE_QUANTITIES_TAB_PRIMARY: "Primary",
   UNAVAILABLE_QUANTITIES_TAB_STATUS: "Status",
   STAGE_CHANGE_FAILED: "An error occurred while updating the stage.",
   // FM transfer fields required by a stage change (uOMM0000.pas:4017-4040). The API refuses the
   // change with the same wording (Messages.resx -> StageChangeFmDispatchProfileRequired /
   // StageChangeFmShipperRequired / StageChangeShipToRequired); these copies let the screen say so
   // before the Shipment dialog opens, which is where Delphi said it.
   FM_DISPATCH_PROFILE_REQUIRED:
      "FM Dispatch Object Profile Cannot Be Blank In Order To Transfer This Record To FM." +
      "<br/>See Trips Tab For More Information.",
   FM_SHIPPER_REQUIRED:
      "Shipper Cannot Be Blank In Order To Transfer This Record To FM." +
      "<br/>See Trips Tab For More Information.",
   FM_SHIP_TO_REQUIRED:
      "Ship To Cannot Be Blank In Order To Transfer This Record To FM." +
      "<br/>See Top of Entry Screen For More Information.",
   // Recalculate Kit Usage Details (IMD0086) Start guard. This is its ONLY home - deliberately not in
   // Messages.resx, because the question has to be asked before the request exists, so a server copy
   // would be unreachable and free to drift. The legacy screen asked nothing at all: the confirmation is
   // a deliberate addition, not AI8 parity. Every outcome message on that screen comes from the API.
   KIT_USAGE_RECALCULATION_CONFIRM_ALL_KITS:
      "No selection criteria have been entered. This will recalculate every kit in the company. Continue?",

   // FM Dispatch Management board (legacy FMD0000). Client-side chrome only: the board is read-only,
   // so the API returns data rather than outcomes and neither of these has a Messages.resx
   // counterpart.
   //
   // There is no "select a profile" text: the board has no picker, because FMD0000 resolves its
   // Dispatching Data Profile from the signed-in user's dispatcher record. Nor is there a "no profile"
   // hint - a user with no dispatcher profile gets an uncoloured board, which is what the desktop does
   // and is not a state worth narrating. The message below is for a lookup that actually FAILED.
   DISPATCH_PROFILE_LOAD_FAILED: "Unable to load the Dispatching Data Profile for this board.",
   DISPATCH_SELECT_RECORD: "Select a record above to see its details.",
   // Shown for the moment between the board mounting and its profile lookup settling. The grid is
   // deliberately not mounted before then: its first load would go out unscoped.
   DISPATCH_LOADING_PROFILE: "Loading...",

   // OM Pre-Commit Transactions (legacy OMD0025).
   //
   // The three account/commit strings are duplicated from Messages.resx rather than fetched: the
   // client asks them locally so an unusable form costs no round trip, and the server keeps the same
   // checks word-for-word because a direct API call must not get past them. The no-filter question is
   // client-only - it is an acknowledgement, not validation: the procedure accepts an empty @InWhere,
   // and the answer changes nothing about what the run does.
   //
   // <br/> rather than a literal newline because DevExtreme confirm() takes messageHtml and puts
   // it into the DOM as markup, where a newline is only whitespace. Verbatim from uOMD0025.pas btnCommitClick.
   PRECOMMIT_NO_FILTER_CONFIRM:
      "No Filter Criteria Was Specified.<br/>Do You Wish To Continue?",
   // Mirrors string.Format(Messages.OmPreCommitAccountNotProvidedFormat, ...) - the two ab_messagedlg
   // calls, asked one at a time with Accrued Receivables first, exactly like the legacy if/else-if
   // chain. Sales Account has no counterpart and must not gain one (approved decision 3).
   PRECOMMIT_ACCRUED_RECEIVABLES_REQUIRED: "Accrued Receivables Account not provided.",
   PRECOMMIT_ACCRUED_PAYABLES_REQUIRED: "Accrued Payables Account not provided.",
   // Mirrors Messages.OmCommitFailedDueToDataErrors, including the legacy's missing "To" before
   // "View" - kept for AI8 parity. Used only as the fallback when the server sent no message of its
   // own (a transport failure); a server-supplied message always wins.
   PRECOMMIT_FAILED: "Commit Process Failed Due To Data Errors - Use Print Errors Button View Report",
   // ab_WaitDialogShow text (uOMD0025.pas btnCommitClick); the legacy double space is collapsed.
   PRECOMMITTING_TRANSACTIONS: "Pre-Committing OM Transactions. Please Wait...",
   PREVIEWING_PRECOMMIT_TRANSACTIONS: "Loading transactions...",
   PRECOMMIT_LOADING_ERRORS: "Loading errors...",

   // WM Transaction Management -> header operations -> Transaction Profile. The picker popup that
   // applies a WMTRANSMANAGEMENTDP profile to the screen; its title and its "nothing picked yet"
   // refusal were the last two literals left inline in that component.
   TRANSACTION_PROFILE_SELECT_TITLE: "Select Transaction Profile",
   TRANSACTION_PROFILE_SELECT_REQUIRED: "Please select a profile.",

   // AI Usage Metrics. The date range's Search refuses an empty date, and a From after the To.
   DATE_RANGE_REQUIRED: "From and To dates are required.",
   FROM_DATE_AFTER_TO_DATE: "From date cannot be after To date.",

   // Update Route/Trips on Orders (uOMD0031) -> grid Options -> Delete All. Legacy omDeleteAllClick
   // cleared every saved transaction off the trip without asking; the web asks first, as the single-row
   // delete does.
   REMOVE_ALL_TRIP_TRANSACTIONS_CONFIRM: "Remove all transactions from this trip?",
   TRIP_TRANSACTIONS_REMOVED: "All transactions removed from the trip.",
   // Update Route/Trips on Orders -> grid Options -> Regenerate Stops (legacy omRegenerateStopsClick).
   TRIP_STOPS_REGENERATED: "Stop numbers regenerated.",
   // Update Route/Trips on Orders -> Update OM Transaction with an empty grid, e.g. straight after Add. Legacy
   // btnUpdateClick updated no rows and said nothing.
   TRIP_HAS_NO_TRANSACTIONS: "Add at least one transaction to the trip before updating.",

   // WM Rate Schedule (uWMD0017 / uWMM0017) - the Delphi BeforePost messages, verbatim.
   RATE_SCHEDULE_CUSTOMER_REQUIRED: "Customer Code Cannot Be Blank For Storage Transaction Schedule.",
   RATE_SCHEDULE_CHARGE_CODE_REQUIRED: "Charge Code CANNOT Be Blank.",
   RATE_SCHEDULE_BILL_TO_REQUIRED: 'Rate "Usage" Flag is Set to "Bill Third Party". The "Bill To Code" CANNOT Be Blank.',
   RATE_SCHEDULE_EMPTY_RATE_CONFIRM: "Rate Source is Set to use the Rate from Rate Schedule Detail - Rate is Empty.<br/>Do You Wish To Continue?",
   RATE_SCHEDULE_EFFECTIVE_DATE_REQUIRED: "Effective Date Cannot Be Blank.",
   // Rule 5: the Charges tab's date grid before the rate schedule header itself has been saved.
   RATE_SCHEDULE_SAVE_HEADER_FIRST: "Save the Rate Schedule first, then add its dates.",
   // uWMD0017.SetParameters posts the profile's template on open; shown when that insert fails.
   RATE_SCHEDULE_DEFAULTS_CREATE_ERROR: "The Rate Schedule Defaults could not be created. Click Save to try again.",
   RATE_SCHEDULE_HEADER_LOAD_ERROR: "Failed to load Rate Schedule Header data.",
   RATE_SCHEDULE_HEADER_SAVE_SUCCESS: "Rate Schedule Header saved successfully.",
   RATE_SCHEDULE_HEADER_SAVE_ERROR: "Failed to save Rate Schedule Header.",
   // uWMD0017.edtP_PROFILEExit - picking a different profile on a new rate schedule.
   PROFILE_CODE_CHANGED_CONFIRM: "You Have Changed Your Profile Code. Continue?",
   // WM Internal Ownership Transfer. OWNERSHIP_TRANSFER_SAME_CUSTOMER mirrors Messages.resx
   // OwnershipTransferSameCustomer (legacy ERR_SAMECUSTOMER); the service raises it for a direct API call.
   OWNERSHIP_TRANSFER_SAME_CUSTOMER: "Cannot Use The Same Customer For Both Shipment And Receipt Transactions. Please, Select Another Customer.",
   OWNERSHIP_TRANSFER_REQUIRED_FIELDS: "Please enter values in required fields.",
   OWNERSHIP_TRANSFER_LOAD_FAILED: "Couldn't load data.",
   OWNERSHIP_TRANSFER_PROFILES_LOAD_FAILED: "Couldnt Load Shipment Profiles ! Refresh the Page.",
   // The Next buttons on the Shipment and Receipt tabs, when what the next step depends on is not chosen yet.
   OWNERSHIP_TRANSFER_SELECT_PROFILE: "Please select values in Profile. Thank You !",
   OWNERSHIP_TRANSFER_SELECT_TAB_VALUES: "Please select values in Shipment tab: Profile & Customer & in Receipt tab: Database, Company & Profile. Thank You!",
   // Select Inventory Location column when the row's stock sits in more than one location.
   OWNERSHIP_TRANSFER_MULTIPLE_LOCATIONS: "Multiple",
   // Legacy texts: FormCloseQuery, ClearSelection and FilterItems (uWM_frmOwnershipTransferDE.pas:402,
   // uWM_dmInventorySelectionDE.pas:729-731, 1093).
   OWNERSHIP_TRANSFER_NOT_APPLIED_EXIT: "The Ownership Transfer Was NOT Applied To The DataBase. Do You Wish To Exit?",
   OWNERSHIP_TRANSFER_CLEAR_SELECTION: "Clear all selected inventory. All Entered Item Transfer Quantities Will Be Lost.<br/>Do You Wish To Continue?",
   OWNERSHIP_TRANSFER_FILTER_NO_ITEMS: "The Current Filter Did Not Return Any Items.",
   OWNERSHIP_TRANSFER_CUSTOMER_NO_ITEMS: "There Are No Items Belonging To The Current Customer.",
   // {0} = shipment number, {1} = shipment facility, {2} = receipt number, {3} = receiving facility.
   OWNERSHIP_TRANSFER_APPLIED: "Applied: shipment {0} in {1}, receipt {2} in {3}. Press Reset to start a new transfer.",
};

export { MESSAGES };
